<template>
  <div id="landing_event_container">
    <official-events :events="events.featured" />
    <div class="landing_slider_container news">
      <recent-news />
    </div>
    <div class="landing_slider_container hub">
      <trending-hubs />
    </div>
    <creator-events :events="events.creator" />
    <high-school-events :events="events.highschool" />
  </div>
</template>

<script>
import { component } from '../../../../../mixins/component';
import OfficialEvents from './OfficialEvents';
import CreatorEvents from './CreatorEvents';
import HighSchoolEvents from './HighSchoolEvents';
import TrendingHubs from '../../TrendingHubs';
import RecentNews from '../../RecentNews';

export default {
  components: { HighSchoolEvents, CreatorEvents, OfficialEvents, TrendingHubs, RecentNews },
  mixins: [component],
  props: {
    events: {
      type: Object,
      default() {
        return {
          featured: {},
          creator: {},
          highschool: {},
        };
      },
    },
  },
};
</script>
